module.exports = __webpack_public_path__ + "img/antiage.9f2843c0.png";